import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import WhatsAppFloating from "../components/WhatsAppFloating";
const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // ✅ ensure page starts at top when navigating here
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const faqs = [
    {
      category: 'Para Novios',
      questions: [
        // {
        //   q: '¿Cuánto cuesta crear mi lista de regalos?',
        //   a: 'Crear tu lista es completamente GRATIS. Solo te pedimos que completes el formulario de registro y nos pondremos en contacto dentro de las 24 horas para activar tu cuenta.'
        // },
        {
          q: '¿Cobran comisión por los regalos?',
          a: 'No. Recibís el 100% del dinero que te regalan directo en tu cuenta bancaria. No cobramos ninguna comisión sobre los regalos.'
        },
        {
          q: '¿Cuándo recibo el dinero de los regalos?',
  a: 'El dinero no pasa por SobreDigital. Los invitados transfieren o pagan directamente a tu cuenta (Mercado Pago, transferencia bancaria, etc.). Los tiempos de acreditación dependen del medio de pago utilizado por cada invitado.'
        },
        {
          q: '¿Puedo personalizar los regalos de mi lista?',
          a: 'Sí! Una vez que tu cuenta esté activa, podés agregar, editar o eliminar regalos, cambiar precios, subir fotos y personalizar completamente tu lista.'
        },
        {
          q: '¿Hasta cuándo puedo tener activa mi lista?',
          a: 'Tu lista permanece activa desde que la creás hasta 60 días después de tu evento. Podés descargar un reporte completo de todos los regalos recibidos en cualquier momento.'
        }
      ]
    },
    {
      category: 'Para Invitados',
      questions: [
        {
          q: '¿Necesito crear una cuenta para regalar?',
          a: 'No. Para hacer un regalo solo necesitás buscar la lista de los novios y elegir el regalo. No hace falta registrarse ni crear ninguna cuenta.'
        },
        {
          q: '¿Qué métodos de pago puedo usar?',
          a: 'Podés pagar con: MercadoPago, transferencia bancaria, depósito bancario, o PayPal (ideal para regalos desde el exterior).'
        },
        {
          q: '¿Puedo hacer un regalo compartido con otros invitados?',
          a: 'Sí! Varios invitados pueden colaborar para un mismo regalo. El sistema suma automáticamente las contribuciones.'
        },
        {
          q: '¿Los novios reciben mi dedicatoria?',
          a: 'Sí. Al hacer tu regalo podés dejar un mensaje personal que los novios verán en su panel junto con tu nombre.'
        },
        // {
        //   q: '¿Es seguro pagar online?',
        //   a: 'Totalmente seguro. Usamos MercadoPago y PayPal, las plataformas de pago más confiables de Latinoamérica. Tus datos están protegidos con encriptación de última generación.'
        // }
      ]
    },
    {
      category: 'General',
      questions: [
        {
          q: '¿En qué países está disponible SobreDigital?',
          a: 'Actualmente estamos disponibles en Argentina. Próximamente expandiremos a Uruguay, Chile y otros países de Latinoamérica.'
        },
        {
          q: '¿Puedo usar SobreDigital para otros eventos además de bodas?',
          a: 'Por ahora nos enfocamos en bodas, pero pronto agregaremos soporte para baby showers, cumpleaños de 15, aniversarios y otros eventos especiales.'
        },
        {
          q: '¿Cómo contacto con soporte?',
          a: 'Podés escribirnos a info@sobredigital.net o usar nuestro formulario de contacto. Respondemos todas las consultas en menos de 24 horas.'
        }
      ]
    }
  ];

  const toggleQuestion = (catIndex, qIndex) => {
    const index = `${catIndex}-${qIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* ✅ use consistent internal page size */}
            <Logo className="h-12 sm:h-14" />
            <Link
              to="/"
              className="text-sm text-neutral-600 hover:text-accent-600 transition-colors"
            >
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-r from-accent-500 to-primary-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Preguntas Frecuentes
          </h1>
          <p className="text-xl text-white/90">
            Todo lo que necesitás saber sobre SobreDigital
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {faqs.map((category, catIndex) => (
          <div key={catIndex} className="mb-12">
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-6 pb-3 border-b-2 border-accent-200">
              {category.category}
            </h2>

            <div className="space-y-4">
              {category.questions.map((faq, qIndex) => (
                <div
                  key={qIndex}
                  className="bg-white rounded-lg shadow-sm border border-neutral-200 overflow-hidden"
                >
                  <button
                    onClick={() => toggleQuestion(catIndex, qIndex)}
                    className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-neutral-50 transition-colors"
                  >
                    <span className="font-semibold text-neutral-900 pr-4">
                      {faq.q}
                    </span>
                    <span className="text-accent-600 text-2xl flex-shrink-0">
                      {openIndex === `${catIndex}-${qIndex}` ? '−' : '+'}
                    </span>
                  </button>

                  {openIndex === `${catIndex}-${qIndex}` && (
                    <div className="px-6 py-4 bg-neutral-50 border-t border-neutral-200 animate-slide-down">
                      <p className="text-neutral-700">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Contact CTA */}
        <div className="mt-16 bg-gradient-to-r from-accent-50 to-primary-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-display font-bold text-neutral-900 mb-3">
            ¿No encontraste tu respuesta?
          </h3>
          <p className="text-neutral-700 mb-6">
            Nuestro equipo está para ayudarte
          </p>
          <Link to="/contacto" className="btn-primary inline-block">
            Contactanos
          </Link>
        </div>
      </main>

      {/* ✅ Footer consistent with new Home */}
      <WhatsAppFloating />
      <footer className="bg-white border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-neutral-500">
              © {new Date().getFullYear()} SobreDigital. Todos los derechos reservados.
            </p>
            <Link to="/" className="text-sm text-neutral-600 hover:text-accent-600 transition-colors">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FAQPage;
